<template>
  <div class="flex flex-col rounded-xl bg-white p-6">
    <h5 class="border-b border-truegray-300 w-full pb-2">
      {{ title }}
    </h5>
    <div
      class="flex flex-col flex-grow items-center justify-around"
      :class="contentClasses"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StatisticsCard',

  props: {
    title: {
      type: String,
      required: true,
    },

    contentClasses: {
      type: String,
      default: '',
    },
  },
})
</script>
